import * as z from 'zod'

import { POSSIBLE_FIN_CATEGORY_KEYS } from '#dictionary'
import { ValuePeriod } from '#domain/types'

import { idNoUnderscoreSchema } from './primitives'

const evaluationStringSchema = z.templateLiteral(['{', z.string().min(1), '}'])
const evaluationOrStringSchema = z.union([z.string(), evaluationStringSchema])
const evaluationOrNumberSchema = z.union([z.number(), evaluationStringSchema])

const finRecordBuilderSchema = z.strictObject({
  categoryKey: z.union([
    z.enum(POSSIBLE_FIN_CATEGORY_KEYS),
    evaluationStringSchema,
  ]),
  value: evaluationOrNumberSchema,
  name: evaluationOrStringSchema.optional(),
  owner: evaluationOrStringSchema.optional(),
  valuePeriod: z
    .union([z.enum(ValuePeriod), evaluationStringSchema])
    .optional(),
  startAtDate: evaluationStringSchema.optional(),
  endAtDate: evaluationStringSchema.optional(),
  startAtAge: evaluationOrNumberSchema.optional(),
  endAtAge: evaluationOrNumberSchema.optional(),
  durationInPeriods: evaluationOrNumberSchema.optional(),
  customGrowthRate: evaluationOrNumberSchema.optional(),
  recurringValue: evaluationOrNumberSchema.optional(),
  realEstateZipCode: evaluationStringSchema.optional(),
  realEstateTaxRate: evaluationStringSchema.optional(),
  if: evaluationStringSchema.optional(),
  subtopicId: idNoUnderscoreSchema.optional(),
  get children() {
    return z.array(finRecordBuilderSchema).optional()
  },
})

export default finRecordBuilderSchema

export type FinRecordBuilder = z.output<typeof finRecordBuilderSchema>
